module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "page-heading",
    class: {
      menuShowing: _vm.menuShowing
    }
  }, [_c('div', {
    staticClass: "menu-button",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "side-menu-button menu-button",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })]), _vm._v(" "), _c('h1', [_c('i', {
    staticClass: "fa",
    class: _vm.pageIcon
  }), _vm._v(" " + _vm._s(_vm.pageTitle))]), _vm._v(" "), _c('div', {
    staticClass: "new-transaction-button-container"
  }, [_c('i', {
    staticClass: "fa fa-plus icon-button",
    attrs: {
      "title": "Add new transaction"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal($event)
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "offlineNoticeShowHide",
      "enter-active-class": "zoomIn",
      "leave-active-class": "zoomOut"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOffline),
      expression: "isOffline"
    }],
    staticClass: "offline-flag header-flag"
  }, [_c('i', {
    staticClass: "fa fa-plug"
  }), _vm._v(" "), _c('span', [_vm._v("You are Offline")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "syncNoticeShowHide",
      "enter-active-class": "zoomIn",
      "leave-active-class": "zoomOut"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transactionsSynced),
      expression: "transactionsSynced"
    }],
    staticClass: "header-flag transactions-synced-flag"
  }, [_c('i', {
    staticClass: "fa fa-cloud"
  }), _vm._v(" "), _c('span', [_vm._v("Transactions synced")])])])], 1), _vm._v(" "), _c('nav', {
    staticClass: "menu",
    class: {
      menuShowing: _vm.menuShowing
    }
  }, [_c('h2', {
    staticClass: "menu-heading menu-button-heading",
    on: {
      "click": function($event) {
        _vm.menuButtonsCollapsed ? _vm.menuButtonsCollapsed = false : _vm.menuButtonsCollapsed = true
      }
    }
  }, [_vm._v("\t\t\n\t\t\tMenu \n\t\t\t"), _c('i', {
    staticClass: "fa pull-right",
    class: {
      'fa-caret-down': _vm.menuButtonsCollapsed, 'fa-caret-up': !_vm.menuButtonsCollapsed
    }
  })]), _vm._v(" "), (!_vm.menuButtonsCollapsed) ? _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus"
  }), _vm._v(" New Transaction")])]), _vm._v(" "), (!_vm.isOffline) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showImportModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-download"
  }), _vm._v(" Import Transactions")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pagesMeta), function(page, key) {
    return ((page.permRequired.indexOf(_vm.userType)) >= 0 && ((!_vm.isOffline && page.nav) || (_vm.isOffline && page.offlinePage))) ? _c('li', [_c('a', {
      attrs: {
        "href": key
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.navigate(key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw",
      class: page.icon
    }), _vm._v(" " + _vm._s(page.title))])]) : _vm._e()
  }), _vm._v(" "), (!_vm.isOffline) ? _c('li', [_vm._m(0)]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bank-accounts-wrapper"
  }, [_c('i', {
    staticClass: "pull-right fa fa-plus icon-button",
    on: {
      "click": _vm.showAccountsModal
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "menu-heading"
  }, [_vm._v("Bank Accounts")]), _vm._v(" "), _c('h3', [_vm._v("On-Budget")]), _vm._v(" "), _c('ul', {
    staticClass: "bank-accounts"
  }, [_vm._l((_vm.bankAccounts), function(account) {
    return (account.off_budget == 0) ? _c('li', {
      staticClass: "account",
      on: {
        "mouseover": function($event) {
          account.editButtonVisible = true
        },
        "mouseleave": function($event) {
          account.editButtonVisible = false
        },
        "click": function($event) {
          _vm.showAccountsModal(account)
        }
      }
    }, [(account.editButtonVisible == true) ? _c('i', {
      staticClass: "fa fa-pencil"
    }) : _vm._e(), _vm._v("\n\t\t\t\t\t" + _vm._s(account.description) + ": "), _c('div', {
      staticClass: "bank-balance",
      class: {
        'text-danger': account.balance < 0, 'text-success': account.balance >= 0
      }
    }, [_vm._v("$ " + _vm._s(account.balance))])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "total"
  }, [_vm._v("Total "), _c('div', {
    staticClass: "bank-balance"
  }, [_vm._v("$ " + _vm._s(_vm.accountBalanceTotals.onBudget.toFixed(2)))])])], 2), _vm._v(" "), _c('h3', [_vm._v("Off-Budget")]), _vm._v(" "), _c('ul', {
    staticClass: "bank-accounts"
  }, [_vm._l((_vm.bankAccounts), function(account) {
    return (account.off_budget == 1) ? _c('li', {
      staticClass: "account",
      on: {
        "mouseover": function($event) {
          account.editButtonVisible = true
        },
        "mouseleave": function($event) {
          account.editButtonVisible = false
        },
        "click": function($event) {
          _vm.showAccountsModal(account)
        }
      }
    }, [(account.editButtonVisible == true) ? _c('i', {
      staticClass: "fa fa-pencil"
    }) : _vm._e(), _vm._v("\n\t\t\t\t\t" + _vm._s(account.description) + ": "), _c('div', {
      staticClass: "bank-balance",
      class: {
        'text-danger': account.balance < 0, 'text-success': account.balance >= 0
      }
    }, [_vm._v("$ " + _vm._s(account.balance))])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "total"
  }, [_vm._v("Total "), _c('div', {
    staticClass: "bank-balance"
  }, [_vm._v("$ " + _vm._s(_vm.accountBalanceTotals.offBudget.toFixed(2)))])])], 2)])]), _vm._v(" "), (_vm.alert.visible) ? _c('div', {
    staticClass: "alert main-alert",
    class: _vm.alert.class
  }, [_vm._v("\n\t\t" + _vm._s(_vm.alert.msg) + "\n\t\t"), (_vm.alert.errors) ? _c('p', [_vm._v(_vm._s(_vm.alert.errors))]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" Logout")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54918c74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardHeader.vue
// module id = 163
// module chunks = 1